import React, {useCallback} from 'react';
import {connect} from 'react-redux';
import {mapCards, updateSelectedCard} from "../../actions/InvoiceActions";
import {getAllPaymentOptions} from "../../selectors/Selectors";
import {useIntl} from "react-intl";

interface PaymentMethodDropdownStoreProps {
    allPaymentOptions: any[];
    selectedCardIndex: string;
}

interface PaymentMethodDropdownDispatchProps {
    updateSelectedCard: (selectedCardKey: string) => any;
}

type PaymentMethodDropdownProps = PaymentMethodDropdownStoreProps & PaymentMethodDropdownDispatchProps;

export function PaymentMethodDropdown(props: PaymentMethodDropdownProps) {
    const intl = useIntl();
    const f = id => intl.formatMessage({id: id});
    const paymentCardOptions = mapCards(props.allPaymentOptions);

    const handlePaymentCardChange = (selectedCard) => {
        if (selectedCard.target.value) {
            props.updateSelectedCard(selectedCard.target.value);
        } else {
            props.updateSelectedCard("");
        }
    };

    return (<div className="col-lg-8 col-md-6 col-sm-6 text-center mb-3 paymentCustomSelect">
        <select
            name="paymentStatus"
            placeholder={f("payment.pay_with")}
            className="form-control"
            value={props.selectedCardIndex}
            onChange={handlePaymentCardChange}>
            <option value="" disabled>{f("payment.pay_with")}</option>
            {paymentCardOptions.map(option => {
                return (
                    <option value={option.value} key={option.index}>
                        {option.label}
                    </option>
                )
            })}
        </select>
        <i className="fas fa-chevron-down select-arrow"/>
    </div>);
}

export const PaymentMethodDropdownConnected = connect<PaymentMethodDropdownStoreProps, PaymentMethodDropdownDispatchProps, any, any>((store:any, props:any) => {
    return {
        allPaymentOptions: getAllPaymentOptions(store),
        selectedCardIndex: store.default.selectedCard,
    }
}, {
    updateSelectedCard
})(PaymentMethodDropdown);

